import { render, staticRenderFns } from "./IconMergeTable.vue?vue&type=template&id=1863fe14"
import script from "./IconMergeTable.vue?vue&type=script&lang=js"
export * from "./IconMergeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports